import React, { useEffect } from "react";
import { CloseButton, Icon, stenaInfoMegaphone } from "@stenajs-webui/elements";
import { Box, Column, Row, Spacing, Txt } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";
import { Notification } from "@stenajs-webui/modal";
import { SubscriptionPayload } from "../../features/notification-center/redux/slice";
import { GapValues } from "@/lib/utils/GapValues";

interface Props {
  subscriptionPayload: SubscriptionPayload;
  onClose: (id: string) => void;
}
const timeToClose = 7 * 1_000;

export const NotificationItem: React.FC<Props> = ({
  subscriptionPayload,
  onClose,
}) => {
  useEffect(() => {
    if (subscriptionPayload.autoClose) {
      const timeoutId = setTimeout(
        () => onClose(subscriptionPayload.id),
        timeToClose
      );

      return () => {
        clearTimeout(timeoutId);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionPayload.autoClose, subscriptionPayload.id]);

  return (
    <Box
      key={subscriptionPayload.id}
      width={400}
      background={cssColor("--lhds-color-ui-50")}
      shadow={"box"}
      spacing={GapValues.SIXTEEN}
      columnGap={GapValues.EIGHT}
    >
      <Row
        indent={GapValues.SIXTEEN}
        justifyContent="space-between"
        alignItems="center"
      >
        <Row gap={GapValues.FOUR} alignItems="center">
          <Row width="40px" justifyContent="center">
            <Icon icon={stenaInfoMegaphone} />
          </Row>
          <Txt variant="bold">{subscriptionPayload.title}</Txt>
        </Row>
        <Row height={"40px"} width={"40px"} alignItems="center">
          <CloseButton onClick={() => onClose(subscriptionPayload.id)} />
        </Row>
      </Row>

      <Row style={{ padding: "0 24px 0 60px " }}>
        <Txt>{subscriptionPayload.text}</Txt>
      </Row>
    </Box>
  );
};
